import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  padding: "0px 20px",
  height: "78vh",
  overflow: "auto",
  marginTop: "20px",
});

export const DetailsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
});
